import React from 'react';
import { Box, Typography, Divider, Grid, SvgIcon } from '@mui/material';

const PhoneIcon = (props) => (
  <SvgIcon {...props} viewBox="0 0 512 512">
    <path d="M164.9 24.6c-7.7-18.6-28-28.5-47.4-23.2l-88 24C12.1 30.2 0 46 0 64C0 311.4 200.6 512 448 512c18 0 33.8-12.1 38.6-29.5l24-88c5.3-19.4-4.6-39.7-23.2-47.4l-96-40c-16.3-6.8-35.2-2.1-46.3 11.6L304.7 368C234.3 334.7 177.3 277.7 144 207.3L193.3 167c13.7-11.2 18.4-30 11.6-46.3l-40-96z" />
  </SvgIcon>
);

const MailIcon = (props) => (
  <SvgIcon {...props} viewBox="0 0 24 24">
    <path
      d="M22 6C22 4.9 21.1 4 20 4H4C2.9 4 2 4.9 2 6V18C2 19.1 2.9 20 4 20H20C21.1 20 22 19.1 22 18V6ZM20 6L12 11L4 6H20ZM20 18H4V8L12 13L20 8V18Z"
      fill="black"
      fillOpacity="0.54"
    />
  </SvgIcon>
);

const MedicalInsuranceCard = ({
  name,
  policy_number,
  age,
  id_number,
  validity,
  group,
}) => {
  return (
    <Box
      sx={{
        fontFamily: 'Lato, sans-serif',
        width: { xs: 'auto', sm: 480, md: 580 },
        minHeight: { xs: 200, sm: 300, md: 360 },
        backgroundColor: '#fff',
        borderLeft: { xs: '30px solid #FFA525', sm: '45px solid #FFA525', md: '60px solid #FFA525' },
        borderRadius: '8px',
        borderRight: '0.5px solid #d9d9d9',
        borderTop: '0.5px solid #d9d9d9',
        borderBottom: '0.5px solid #d9d9d9',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'space-between',
        overflow: 'hidden',
        position: 'relative',
      }}
    >
      <Box sx={{ padding: { xs: '6px', sm: '8px', md: '10px' } }}>
        <Typography
          variant="h6"
          sx={{
            fontSize: { xs: 14, sm: 17, md: 20 },
            fontWeight: 700,
            textTransform: 'uppercase',
            paddingX: 1,
          }}
        >
          Medical Insurance Card
        </Typography>
        <Box
          sx={{
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            mt: { xs: 1, sm: 1.5, md: 2 },
            mb: { xs: 0.8, sm: 1, md: 1.2 },
            borderBottom: '1px solid #ccc',
            px: 1,
            pb: 1,
          }}
        >
          <img
            src="https://d2djimvzddgguw.cloudfront.net/humbee-insurance-card/iffco_tokyo_logo.png"
            alt="iffco tokio"
            style={{ height: 'clamp(20px, 4vw, 30px)' }}
          />
          <img
            src="https://d2djimvzddgguw.cloudfront.net/humbee-insurance-card/humbee_logo.png"
            alt="Humbee"
            style={{ height: 'clamp(20px, 4vw, 30px)' }}
          />
        </Box>
      </Box>

      <Box
        sx={{
          position: 'absolute',
          right: {xs:-40, sm:-50, lg: -60},
          top: { xs: 80, sm: 90, md: 100 },
          bottom: { xs: 45, sm: 55, md: 65 },
          width: { xs: 120, sm: 160, md: 200 },
          backgroundImage:
            "url('https://d2djimvzddgguw.cloudfront.net/humbee-benefit-icons/MI_icon.png')",
          backgroundRepeat: 'no-repeat',
          backgroundSize: 'contain',
          opacity: 0.15,
          zIndex: 0,
        }}
      />
      <Box sx={{ px: 1, position: 'relative', zIndex: 1 }}>
        <Box sx={{ px: 1, display:'flex', justifyContent: 'space-between' }}>
          <Box>
            <Typography fontSize={{ xs: 10, sm: 12, md: 14 }} color="#000">
              Name
            </Typography>
            <Typography fontSize={{ xs: 12, sm: 15, md: 18 }} fontWeight={700} color="#000">
              {name}
            </Typography>
          </Box>
          <Box sx={{ minWidth: { xs: 100, sm: 120, md: 150 } }}>
            <Typography fontSize={{ xs: 10, sm: 12, md: 14 }} color="#000">
              Policy Number
            </Typography>
            <Typography fontSize={{ xs: 12, sm: 15, md: 18 }} fontWeight={700} color="#000">
              {policy_number}
            </Typography>
          </Box>
        </Box>

        <Box sx={{ mt: { xs: 1, sm: 1.2, md: 1.5 }, px: 1 }}>
          {[
            { label: 'Age', value: age },
            { label: 'ID No.', value: id_number },
            { label: 'Validity', value: validity },
            { label: 'Group', value: group },
          ].map((item, index) => (
            <Box key={index} sx={{ display: 'flex', mb: { xs: 0.5, sm: 0.8, md: 1 } }}>
              <Typography fontSize={{ xs: 10, sm: 12, md: 14 }} color="#000" sx={{ minWidth: { xs: 60, sm: 80, md: 100 } }}>
                {item.label}
              </Typography>
              <Typography fontSize={{ xs: 11, sm: 13, md: 16 }} fontWeight={700} color="#000">
                {item.value}
              </Typography>
            </Box>
          ))}
        </Box>
      </Box>
      <Box sx={{ p: { xs: 0.5, sm: 0.8, md: 1 } }}>
        <Box
          sx={{
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
          }}
        >
          <Typography
            fontSize={{ xs: 8, sm: 9, md: 11 }}
            color="#000"
            fontWeight={600}
            textTransform="uppercase"
          >
            TPA Contact Details
          </Typography>
          <Typography fontSize={{ xs: 7, sm: 8, md: 10 }} color="#000">
            *T&C Applied
          </Typography>
        </Box>

        <Divider sx={{ my: 0.5, borderColor: '#ccc' }} />

        <Box
          sx={{
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            fontSize: { xs: 8, sm: 10, md: 12 },
            color: '#00000080',
            px: 1,
            flexWrap: { xs: 'wrap', sm: 'nowrap' },
            gap: { xs: 0.5, sm: 0 }
          }}
        >
          <Box sx={{ display: 'flex', alignItems: 'center' }}>
            <PhoneIcon sx={{ fontSize: { xs: 10, sm: 12, md: 14 }, mr: 0.5 }} />
            0124-4722050/20/23
          </Box>
          <Box sx={{ display: 'flex', alignItems: 'center' }}>
            <MailIcon sx={{ fontSize: { xs: 12, sm: 14, md: 16 }, mr: 0.5 }} />
            healthclaims@iffcotokio.co.in
          </Box>
          <Box sx={{ display: 'flex', alignItems: 'center' }}>
            <PhoneIcon sx={{ fontSize: { xs: 10, sm: 12, md: 14 }, mr: 0.5 }} />
            Toll Free: 1800-103-5499
          </Box>
        </Box>
      </Box>
    </Box>
  );
};

export default MedicalInsuranceCard;
